var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-alert u-padding-bottom-xlarge-xs-down u-margin-top-small o-alert--danger u-margin-0"},[_c('i',{staticClass:"icofont-ui-lock"}),_vm._v(" "+_vm._s(_vm.$t("batteryDetail.isLockedDescription"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }